import React from "react";
import "./App.css";
import NavHead from "./NavHead";

function App() {
  return (
    <div>
      <NavHead />
    </div>
  );
}

export default App;
